import React from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, CardHeader, CardTitle,
    // ListGroup, 
    ListGroupItem
} from 'reactstrap';
import { Collapse, Empty } from 'antd';

const { Panel } = Collapse;

FastestPerformance.propTypes = {
    items: PropTypes.array,
}

FastestPerformance.defaultProps = {
    heading: 'Heading',
    items: []
};

function FastestPerformance({ items }) {
    let listItems = items.map((item, i) => (
        <ListGroupItem key={i}>
            <span className="font-weight-bold pull-left">{item.subject || 'NA'}</span>
            <span className="pull-right">Time per ques: {item.timePerQues || 0} sec</span> <br />
            <span className="pull-right">Accuracy: {item.accuracy || 0}%</span> <br />
            <span className="pull-left"> Chapter: {item.chapter || 'NA'} </span>
            <span className="pull-right"> Ques Answered : {item.quesAnswered || 0} </span>

            {/* <div className="row">
                            <div className="col-md-12 ">
                                <div className="detail-label">Chapter: </div>
                                <div className="detail-value">{item.chapter || 'NA'}</div>
                            </div>

                            <div className="col-md-6">
                                <div className="detail-label">Average time per question: </div>
                                <div className="detail-value"> {item.timePerQues || 0} sec</div>
                            </div>

                            <div className="col-md-6">
                                <div className="detail-label"> Questions attempted : </div>
                                <div className="detail-value"> {item.quesAnswered || 0}</div>
                            </div>

                        </div> */}
        </ListGroupItem>
    ));

    if (!listItems.length) {
        listItems = (
            <ListGroupItem>
                {/* <span>No data found.</span> */}
                <Empty />
            </ListGroupItem>
        )
    }

    let newListItem;
    if (items !== undefined) {
        newListItem = (

            <Panel header={items[0].subject}>
                {items.slice(0, 3).map((item, i) => (
                    <ListGroupItem key={i}>

                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <div className="detail-label">Chapter:</div>
                                <div className="detail-value"> {item.chapter || 'NA'}</div>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-md-6">
                                <div className="detail-label">Average time per question:</div>
                                <div className="detail-number"> <icon className="icon-time-1 text-icon-big"></icon>{item.timePerQues || 0}<span className="text-normal">Sec</span> </div>
                            </div>

                            <div className="col-md-6">
                                <div className="detail-label"> Questions attempted : </div>
                                <div className="detail-number"> {item.quesAnswered || 0}</div>
                            </div>

                        </div>
                        {/* <span className="pull-right">Average time per question: {item.timePerQues || 0} sec</span> <br /> */}
                        {/* <span className="pull-right">Accuracy: {item.accuracy || 0}%</span> <br /> */}
                        {/* <span className="pull-left"> Chapter: {item.chapter  || 'NA'} </span> */}
                        {/* <span className="pull-right"> Questions attempted : {item.quesAnswered || 0} </span> */}
                    </ListGroupItem>
                ))
                }
            </Panel>
        )
    }



    return (
        <Card className="card-shadow">
            <CardHeader>Fastest Performances</CardHeader>
            <CardBody>
                {/* <CardTitle className="mb-2"></CardTitle> */}
                {/* <ListGroup>
                    {listItems}
                </ListGroup> */}
                <Collapse accordion defaultActiveKey={['0']} >
                    {newListItem}
                </Collapse>
            </CardBody>
        </Card>
    )
}

export default FastestPerformance;

